function MallIcon({
    iconName,
    size,
    color,
    style,
}: MallIconProps & React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement>, HTMLElement>) {
    let translatedSize;
    let translatedColor;
    switch (size) {
        case 'nav':
            translatedSize = '25px';
            break;
        case 'search':
            translatedSize = '20px';
            break;
        case 'mypage':
            translatedSize = '25px';
            break;
        case 'noCart':
            translatedSize = '40px';
            break;
        case 'link':
            translatedSize = '16px';
            break;
        case 'mall-link':
            translatedSize = '35px';
            break;
        default:
            break;
    }
    switch (color) {
        case 'white':
            translatedColor = '#fff';
            break;
        case 'black':
            translatedColor = '';
            break;
        case 'gray':
            translatedColor = '#999999';
            break;
        default:
            break;
    }
    return (
        <i
            className={`lazymall-${iconName}`}
            style={{
                fontSize: `${size && translatedSize}`,
                color: `${color && translatedColor}`,
                display: 'flex',
                flexDirection: 'column',
                ...style,
            }}
        />
    );
}

export default MallIcon;

export interface MallIconProps {
    iconName:
        | 'back-arrow'
        | 'bag'
        | 'del'
        | 'down'
        | 'down-arrow'
        | 'home'
        | 'home-w'
        | 'minus'
        | 'mt-faq'
        | 'my-address'
        | 'my-ask'
        | 'my-mileage'
        | 'my-order'
        | 'my-return'
        | 'plus'
        | 'right-arrow'
        | 'search'
        | 'share'
        | 'top-arrow'
        | 'up-arrow'
        | 'user'
        | 'pin'
        | 'profile-link'
        | 'phone'
        | 'write'
        | 'talk'
        | 'coupon';

    size?: 'nav' | 'other1' | 'other2' | 'search' | 'mypage' | 'productBag' | 'noCart' | 'link' | 'mall-link';
    color?: 'white' | 'black' | 'other1' | 'other2' | 'gray';
}
